import React, { useEffect, useState } from 'react';

import { useIntl } from 'react-intl';
import { Button, Col, Row } from 'react-bootstrap';

import { useAppSelector } from 'hooks';
import { SectionTitle } from 'components/UI';
import { isPatientArchived } from 'store/patient/reducer';

import EducationalContent from './EducationalContent';
import AddEditEducationalContentModal from './EducationalContent/AddEditEducationalContentModal';

interface IEducationalContentsProps {
  educationalContents: ICarePlanEducationalContent[] | undefined;
  getCarePlan: any;
  carePlanTemplate?: ICarePlanTemplate;
}

const EducationalContents = ({
  educationalContents,
  getCarePlan,
  carePlanTemplate
}: IEducationalContentsProps) => {
  const intl = useIntl();
  const [showAddModal, setShowAddModal] = useState(false);
  const [_educationalContents, setEducationalContents] = useState(educationalContents || []);
  const isTemplateGlobal = carePlanTemplate?.template_type === 'GLOBAL';
  const _isPatientArchived = useAppSelector(isPatientArchived);
  const handleOpenAddModal = () => {
    setShowAddModal(true);
  };
  const handleCloseAddModal = () => {
    setShowAddModal(false);
  };
  const handleAddEducationalContent = () => {
    handleCloseAddModal();
    getCarePlan();
  };
  const handleEditEducationalContent = () => {
    getCarePlan();
  };
  const onDeleteEducationalContent = (id: string) => {
    setEducationalContents(_educationalContents.filter((elem) => elem.id !== id));
  };

  useEffect(() => {
    setEducationalContents(educationalContents || []);
  }, [educationalContents]);

  return (
    <div className="mb-5">
      <div className="d-flex justify-content-between align-items-center">
        <SectionTitle
          dataTestId="careplan-educational-contents-title"
          label={intl.formatMessage({ id: 'educationalContentKey' })}
          pill="APP"
        />
        {!isTemplateGlobal && (
          <Button
            variant="link"
            size="sm"
            onClick={handleOpenAddModal}
            data-test="careplan-educational-contents-btn"
            disabled={_isPatientArchived}
          >
            + {intl.formatMessage({ id: 'educationalContentKey' })}
          </Button>
        )}
      </div>
      <Row>
        {_educationalContents && _educationalContents?.length > 0 ? (
          _educationalContents.map((educationalContent, index) => (
            <EducationalContent
              dataTestId={`careplan-educational-content-${index}`}
              educationalContent={educationalContent}
              key={educationalContent.id}
              handleEdit={handleEditEducationalContent}
              onDelete={onDeleteEducationalContent}
              carePlanTemplate={carePlanTemplate}
              disabled={_isPatientArchived}
            />
          ))
        ) : (
          <Col>
            <div
              className="bg-light text-center p-3 font-weight-bolder"
              data-test="careplan-educational-contents-empty"
            >
              {intl.formatMessage({ id: 'noEducationalContentScheduled' })}
            </div>
          </Col>
        )}
      </Row>

      {showAddModal && (
        <AddEditEducationalContentModal
          show={showAddModal}
          handleClose={handleCloseAddModal}
          handleEdit={handleAddEducationalContent}
          carePlanTemplate={carePlanTemplate}
        />
      )}
    </div>
  );
};

export default EducationalContents;
